import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SetupNewPasswordComponent } from './dashboard/pages/setup-new-password/setup-new-password/setup-new-password.component';

const routes: Routes = [
  {
    path: '', 
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule) 
  
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
